import { gql, useMutation, useQuery } from '@apollo/client'

import {
  ItemDetailBoxFragmentDoc,
  ObtainSerialMutation,
  ObtainSerialMutationVariables,
  QRcodeGetItemQuery,
  QRcodeGetItemQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'
import { setItemSku } from '@/core/sku'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { router } = useRouter<{
    itemId: string
    serialId: string
  }>()
  const { data, loading } = useQuery<
    QRcodeGetItemQuery,
    QRcodeGetItemQueryVariables
  >(QUERY, {
    variables: {
      itemId: router.query.itemId,
      serialId: router.query.serialId,
    },
  })
  const [getItem, { loading: gettingItem }] = useMutation<
    ObtainSerialMutation,
    ObtainSerialMutationVariables
  >(MUTATION, {
    variables: {
      itemId: router.query.itemId,
      serialId: router.query.serialId,
    },
  })

  return {
    state: {
      loading,
      itemId: router.query.itemId,
      item: setItemSku(data?.item, data?.item?.serial?.skuId ?? null),
      user: user ?? null,
      gettingItem,
    },
    actions: {
      onGetItem: async () => {
        await getItem()
      },
    },
  }
})

const MUTATION = gql`
  mutation ObtainSerial($itemId: ID!, $serialId: ID!) {
    obtainSerial(itemId: $itemId, serialId: $serialId) {
      id
      isPurchased
      serial(id: $serialId) {
        id
        skuId
        authentication {
          authenticatedAt
        }
      }
    }
  }
`

const QUERY = gql`
  query QRcodeGetItem($itemId: ID!, $serialId: ID!, $skuId: String) {
    item(id: $itemId) {
      ...ItemDetailBox
      serial(id: $serialId) {
        id
        authentication {
          authenticatedAt
        }
        skuId
      }
    }
  }
  ${ItemDetailBoxFragmentDoc}
`
